import React from 'react';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { useCurrentCity } from '@cp/entities/location';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { useClientWebRouteParams } from '@cp/entities/clientWebRoutes';
import { View } from './view';

export const PageFooter: React.FC = () => {
  const isMobile = useIsMobile();
  const { pageId, hasCitySeparatedContent } = useClientWebRouteParams();
  const { currentCity } = useCurrentCity({ allowEmptyValue: true });

  if (hasCitySeparatedContent && !currentCity) {
    return null;
  }

  if (pageId === ClientWebPage.SignupProvider) {
    return null;
  }

  if (pageId === ClientWebPage.Catalog && isMobile) {
    return null;
  }
  if (pageId === ClientWebPage.ProfileVacancies && isMobile) {
    return null;
  }

  if (pageId === ClientWebPage.ProfilePhoto) {
    return null;
  }

  if (pageId === ClientWebPage.ProfileMessages && isMobile) {
    return null;
  }

  if (pageId === ClientWebPage.ProfileSchedule && isMobile) {
    return null;
  }

  if (pageId === ClientWebPage.ProfileFavorites && isMobile) {
    return null;
  }

  if (pageId === ClientWebPage.ProfileRegularPartners && isMobile) {
    return null;
  }

  if (pageId === ClientWebPage.OAuth) {
    return null;
  }

  if (pageId === ClientWebPage.Intro) {
    return null;
  }

  return <View />;
};
